import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { WorkOrder } from '../models/work-order.model';
import { PagedRequest } from '../models/requests/paged-request';
import {
  ClearUserSelectedDataRequest,
  ClearOperationResponse,
} from '../models/requests/clear-user-selected-data-request';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderService {
  constructor(private apiService: ApiService) {}

  public getPaged(
    request: PagedRequest,
  ): Observable<{ Items: WorkOrder[]; TotalRecords: number }> {
    return this.apiService.post<{ Items: WorkOrder[]; TotalRecords: number }>(
      `/WorkOrder/GetWorkOrdersForSanitization`,
      request,
    );
  }

  public updateSelectedPriority(
    workOrderId: string,
    selectedPriority: string,
  ): Observable<WorkOrder> {
    return this.apiService.post(`/WorkOrder/UpdateSelectedPriority`, {
      WorkOrderId: workOrderId,
      selectedPriority: selectedPriority,
    });
  }

  public getExportWorkOrdersPrioritiesToChange(
    filters: Record<string, any> = {},
  ): Observable<string> {
    return this.apiService.post<string>(
      `/WorkOrder/ExportWorkOrdersPrioritiesToChange`,
      filters,
      undefined,
      false,
      undefined,
      undefined,
      'text',
    );
  }

  public getExportWorkOrdersWithDuplicates(
    filters: Record<string, any> = {},
  ): Observable<string> {
    return this.apiService.post<string>(
      `/WorkOrder/ExportWorkOrdersWithDuplicates`,
      filters,
      undefined,
      false,
      undefined,
      undefined,
      'text',
    );
  }

  public clearSelectedPriorities(
    request: ClearUserSelectedDataRequest,
  ): Observable<ClearOperationResponse> {
    return this.apiService.post<ClearOperationResponse>(
      `/WorkOrder/ClearSelectedPriorities`,
      request,
    );
  }
}
